import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4 5h16M4 12h16M4 19h16"
    }, null, -1)
  ])]);
}
const Menu01StrokeRoundedIcon = { render };
export {
  Menu01StrokeRoundedIcon as default,
  render
};
//# sourceMappingURL=menu-01-stroke-rounded.svg.js.map
